export default __webpack_public_path__ + "static/media/marauders-map-v3-01-00.2c3d123a.jpg";